// extracted by mini-css-extract-plugin
export default {"grid":"ProductGrid_grid__s2xpv"};